import { render, staticRenderFns } from "./SalvarConfiguracaoMultiplosProdutosAnalisePorLote.vue?vue&type=template&id=7530bafe&scoped=true"
import script from "./SalvarConfiguracaoMultiplosProdutosAnalisePorLote.vue?vue&type=script&setup=true&lang=js"
export * from "./SalvarConfiguracaoMultiplosProdutosAnalisePorLote.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SalvarConfiguracaoMultiplosProdutosAnalisePorLote.vue?vue&type=style&index=0&id=7530bafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7530bafe",
  null
  
)

export default component.exports